import type { UseQueryResult } from '@tanstack/react-query';

import type { AccountInfoOutput } from '@core/types/api/AccountInfoOutput/AccountInfoOutput';

import type { QueryError } from '../utils/Query';
import { useSlabQuery } from './useSlabQuery';

export const useNylasGrantInfo = (): UseQueryResult<AccountInfoOutput, QueryError> =>
  useSlabQuery(
    'GET nylas v3 grant info',
    {},
    {
      retry: (fc, err) => err.response?.status !== 401 && fc < 4,
    },
  );
